import React from 'react';
import UserDataContext from 'types/UserDataContext';

const UserContext = React.createContext<UserDataContext>(undefined as unknown as UserDataContext);

export default UserContext;
